module.exports = __webpack_public_path__ + "static/img/empty.2ca2d72.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fyImg/empty.png
// module id = w0GL
// module chunks = 3